export default "__VITE_ASSET__CNIbQO5z__"